import PitchRow from "./PitchRow";
import "./Pitch.css";

export default function Pitch({
  formation,
  lineup,
  onSlotClick,
  onRowReorder,
}) {
  if (!formation) return null;

  const rows = Object.values(formation.rows);

  // 🔧 TUNING VALUES (easy to tweak)
  const GK_OFFSET = 10; // % from bottom (⬆️ move GK up)
  const ROW_GAP = 18;   // % gap between rows (⬆️ more space)

  return (
    <div className="pitch">
      <div className="pitch-players">
        {rows.map((slots, index) => {
          const isKeeper = index === 0;

          const rowBottom = isKeeper
            ? `${GK_OFFSET}%`
            : `${GK_OFFSET + index * ROW_GAP}%`;

          return (
            <PitchRow
              key={index}
              slots={slots}
              lineup={lineup}
              onSlotClick={onSlotClick}
              onRowReorder={onRowReorder}
              className={isKeeper ? "gk-row" : "outfield-row"}
              style={{ "--row-bottom": rowBottom }}
            />
          );
        })}
      </div>
    </div>
  );
}
